// 🚨 AUTO-GENERADO desde ProfileFormDataType.ts - No editar manualmente

export const SuscriptionFormDataKeys = [
  "id",
  "numero",
  "nombre",
  "nombre_comercial",
  "fecha_pago",
  "monto",
  "activo",
  "email",
  "telefono1",
  "telefono1_cd",
  "telefono2",
  "telefono2_cd",
  "tipo_identificacion",
  "identificacion",
  "report_format",
  "pais",
  "province_id",
  "canton_id",
  "district_id",
  "neiboard_id",
  "direccion",
  "datasource",
  "invoice_info",
  "quote_info",
  "consignment_info",
  "consignmentmodification_info",
  "hold_info",
  "order_info",
  "settlement_info",
  "invoice_email",
  "qoute_email",
  "consignment_email",
  "creditnote_email",
  "debitnote_email",
  "providerorder_email",
  "recibe_email",
  "settlement_email",
  "clientstatus_email",
  "order_email",
  "block_on_limit",
  "formato_impresion",
  "prefijo_facturacion",
  "dias_apartado",
  "dias_notadebito",
  "quick_save_button",
  "auto_print",
  "ask_confirm",
  "no_auto_cancel_contado",
  "aditional_ticket_copy",
  "reprint_copies",
  "notes_printcopies",
  "recibe_printcopies",
  "invoice_printcopies",
  "items_per_page",
  "detail_font_size",
  "schema_created",
  "vencimiento",
  "aplicar_imp_servicio",
  "comision_producto",
  "include_full_desc",
  "imp_servicio",
  "persistent",
  "host",
  "db_name",
  "prefix",
  "suscriptionkind_id",
  "pricemanaged",
  "percent_per_item",
  "sync_dolar",
  "order_recibe_by_created",
  "reduce_stock_on_settlement",
  "einvoice_status",
  "einvoice_p12",
  "einvoice_p12Asset",
  "einvoice_password",
  "einvoice_atvuser",
  "einvoice_atvpassword",
  "einvoice_sandbox",
  "einvoice_sequence_suscription_id",
  "printer_url",
  "shipping_cost",
  "shipping_product_id",
  "create_shipping_guide",
  "inventario_negativo",
  "last_copy_name",
  "bcc_email",
  "use_easypos_email",
  "invoice_order",
  "reference_label",
  "show_reference",
  "show_zone_saleman_on_clients",
  "quote_approval_flow",
  "auto_fit_comments_font",
  "show_taxpercent",
  "recalculateCurrency",
  "bank_account_on_docs",
  "disabled_acl",
  "single_dayclose",
  "interest_on_due",
  "is_interest_on_due",
  "beta_tester",
  "auto_cancel_rejected",
  "interest_product_id",
  "api_enabled",
  "api_username",
  "api_password",
  "api_password_updated_at",
  "use_alternative_icon",
  "select_logo",
  "logo",
  "logoAsset",
  "logo2",
  "logo2Asset",
  "logo3",
  "logo3Asset",
  "watermark",
  "watermarkAsset"
] as const;
